import { render } from "./country-update.vue?vue&type=template&id=582c09cf"
import script from "./country-update.vue?vue&type=script&lang=js"
export * from "./country-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__